<template>
  <component :is="active" :data="data" @changeStatus="changeStatus"></component>
</template>

<script>
export default {
  name: 'reset',
  mixins: [],
  data() {
    return {
      active: 'RegisterForm',
      data: {
        isSetCookie: true
      }
    }
  },
  components: {
    //表单页
    RegisterForm: () => import('@/views/register/IframeGroupRegister.vue'),
    //注册成功页
    Success: () => import('@/views/register/Success.vue'),
    //发送邮件成功页
    SendEmail: () => import('@/views/register/SendEmail.vue'),
    //验证邮箱链接页
    VerifyEmail: () => import('@/views/register/VerifyEmail.vue'),
    //邮箱链接失效页
    LinkError: () => import('@/views/register/LinkError.vue')
  },
  created() {
    this.checkUrl()
  },
  mounted() {
    //此方法刷新页面时也会执行
    window.addEventListener('beforeunload', () => {
      sessionStorage.removeItem('sendData')
    })

    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 600)
  },
  methods: {
    changeStatus(status, data) {
      this.active = status
      this.data = data
    },
    checkUrl() {
      //判断url中是否有token和uid   如果有的话 跳转到验证邮箱链接页
      if (this.$route.query.token && this.$route.query.uid) {
        //eslint-disable-next-line
        if ($('#timeOut').val() === 'false') {
          this.active = 'VerifyEmail'
        } else {
          this.active = 'LinkError'
        }
      }
    }
  }
}
</script>
